import React from 'react';

import { colors, fonts, container, line } from '../theme';
import { categories } from '../data';

export default function Categories() {
  return (
    <section style={{ borderTop: line.faint, borderBottom: line.faint }}>
      <div
        className="lyfe-reveal lyfe-wrap lyfe-cats"
        style={{
          ...container,
          padding: '34px 40px',
          display: 'flex',
          alignItems: 'center',
          gap: 40,
          flexWrap: 'wrap',
        }}>
        <span
          style={{
            fontFamily: fonts.serif,
            fontStyle: 'italic',
            fontSize: 22,
            color: colors.muted2,
            whiteSpace: 'nowrap',
          }}>
          Where to go next?
        </span>
        <div className="lyfe-cats-tags" style={{ display: 'flex', gap: 14, flexWrap: 'wrap', flex: 1 }}>
          {categories.map((c) => (
            <span
              key={c}
              style={{
                border: '1px solid rgba(255,255,255,.14)',
                borderRadius: 999,
                padding: '10px 22px',
                fontSize: 15,
              }}>
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
